let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gxkhQ"), load("iPuyw"), load("ffEVr"), load("bAAmE"), load("irgIM")]).then(() => parcelRequire('cbZqw'));